








































import Vue from 'vue';

// import EbMedia from '../components/EbMedia.vue';

export default Vue.extend({
  // components: {
  //   EbMedia,
  // },
});
